export default __webpack_public_path__ + "static/media/codigo-conduta.ead1cdbf.pdf";